import styled from "styled-components"

const LabelContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Pretendard Variable';
    font-weight: 600;
    font-size: 0.875rem;
    color: white;
    padding: 0.21875rem 0;
`

const RedLabelContainer = styled(LabelContainer)`
    background-color: #FF3131;
`

const BlueLabelContainer = styled(LabelContainer)`
    background-color: #316BFF;
`

const GreenLabelContainer = styled(LabelContainer)`
    background-color: #08A900;
`

const LabelColorMap = {
    'SP1': RedLabelContainer,
    'SP2': RedLabelContainer,
    'SP3': RedLabelContainer,
    'SP4': RedLabelContainer,
    'SP5': RedLabelContainer,
    'WIN': BlueLabelContainer,
    'CHA': BlueLabelContainer,
    'LNG': BlueLabelContainer,
    'CP': GreenLabelContainer,
}


const LabelNameMap = {
    'SP1': '1선발',
    'SP2': '2선발',
    'SP3': '3선발',
    'SP4': '4선발',
    'SP5': '5선발',
    'WIN': '승리조',
    'CHA': '추격조',
    'LNG': '롱릴리프',
    'CP': '마무리',
}

export default function PitcherLabel({ position }) {

    const SelectedContainer = LabelColorMap[position] || LabelContainer;

    const SelectedName = LabelNameMap[position] || position;

    return (
        <SelectedContainer>
            {SelectedName}
        </SelectedContainer>
    )
}